/**
 * Shared helpers for report navigation anchors and labels.
 * Keep logic centralized so createReportView, ReportDetail, and PDF rendering stay aligned.
 */

export function splitSectionTitle(title: string): {
  label: string;
  unitLabel?: string;
} {
  const [rawLabel, rawUnitLabel] = title.split('—').map((part) => part.trim());
  return {
    label: rawLabel,
    unitLabel: rawUnitLabel || undefined,
  };
}

export function extractUnitIndex(sectionId: string): number | null {
  const match = sectionId.match(/\[(\d+)(?:,\d+)*\]/);
  return match ? Number(match[1]) : null;
}

export function buildAnchorId(anchor: string): string {
  return `section-${anchor}`;
}
